import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect x={0.5} y={0.5} width={39} height={39} rx={19.5} fill="#fff" />
        <rect x={0.5} y={0.5} width={39} height={39} rx={19.5} stroke={theme["#B4E3E1"]} />
        <path
            d="M25.833 22.5a3.332 3.332 0 00-3.333 3.333c0 .625.175 1.217.483 1.717a3.308 3.308 0 002.85 1.617c1.217 0 2.275-.65 2.85-1.617.309-.5.484-1.092.484-1.717a3.332 3.332 0 00-3.334-3.333zm1.725 2.975l-1.775 1.642a.636.636 0 01-.425.166.618.618 0 01-.441-.183l-.825-.825a.629.629 0 010-.883.629.629 0 01.883 0l.4.4 1.333-1.234a.63.63 0 01.884.034.63.63 0 01-.034.883zM28.333 16.292v.375a.836.836 0 01-.834.833h-15a.836.836 0 01-.833-.833v-.384a3.446 3.446 0 013.45-3.45h9.758a3.46 3.46 0 013.459 3.459z"
            fill={theme["#0D968F"]}
        />
        <path
            d="M11.666 19.583v4.134a3.446 3.446 0 003.45 3.45h5.217c.483 0 .9-.409.858-.892-.117-1.275.292-2.658 1.425-3.758a4.232 4.232 0 011.667-1.009 4.663 4.663 0 012.941.009.834.834 0 001.109-.784v-1.158a.836.836 0 00-.834-.833h-15a.848.848 0 00-.833.841zm5 4.792h-1.667a.63.63 0 01-.625-.625.63.63 0 01.625-.625h1.667a.63.63 0 01.625.625.63.63 0 01-.625.625z"
            fill={theme["#0D968F"]}
        />
        </svg>
    )
}
  
  export default SvgComponent